import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { resetModel } from '../../../../store/components/modelSlice';
import useSearch from '../../../../hook/useSearch';
import { PaginationProvider } from '../../../../context/pageContext';
import Search from '../../../../views/search';
import Pagination from '../../../../components/pagination';
import Table from '../../../../components/table';
import { getMemberVehicleConnectHistory } from '../../../../services/dashboard/member';
import dayjs from 'dayjs';

const searchs = [
    {
        "key": "rangePicker",
        "type": "rangePicker",
        "label": "查詢時間區間"
    }
]

const Connectionmodal = () => {
    const [show, setShow] = useState(true);
    const dispatch = useDispatch();
    const content = useSelector((state) => state.model.data);
    const [condition, setCondition, setPagination] = useSearch();
    const [source, setSource] = useState([]);
    const [tablePages, setPages] = useState(0);
    const [hasSearched, setHasSearched] = useState(false);

    const getSourceHandler = () => {
        setHasSearched(true);
        const modifiedCondition = {
            ...condition,
            vinNumber : content.vehicleNumber,
            startDate: condition.start ? new Date(condition.start).getTime() : undefined,
            endDate: condition.end ? new Date(condition.end).getTime() : undefined,
        };

        getMemberVehicleConnectHistory( modifiedCondition)
            .then(response => {
                const { data, totalCount } = response.data;
                setSource(data);
                setPages(totalCount);
            })
            .catch(error => {
                setSource([]);
                setPages(0);
            });
    };

    const cancelHandler = () => {
        setShow(false);
        dispatch(resetModel()); 
    };

    useEffect(() => { if (hasSearched) { getSourceHandler(); } }, [condition.skip]);

    return (
        <PaginationProvider pagination={{ condition, setPagination }}>
            <Modal className='driver-model' show={ show } onHide={ cancelHandler } centered size='lg'>
                <Modal.Header className="model_title" closeButton style={{color:'#fff'}}>連線紀錄</Modal.Header>
                <Modal.Body>
                    <div className="custom-tabs-container">
                        <div className="tab-content">
                            <div className="list-container">
                                <div className="item-content">
                                    <div className="label">VIN</div>
                                    <div className="content" type="text" >{content.vehicleNumber}</div>
                                </div >
                                <div className="item-content">
                                    <div className="label">車牌</div>
                                    <div className="content" type="text" >{content.carNo}</div>
                                </div >
                            </div>
                        </div>
                    </div>
                    <p></p>
                    <Search resource={ searchs } condition={ condition } onSubmit={ setCondition } />
                    <div className="activity-container">
                        <Pagination totalCount={ tablePages } style={{ width: 'auto' }} />
                        <div className="action-container">
                            <Button variant="primary" onClick={ getSourceHandler }>查詢</Button>
                        </div>
                    </div>
                    <div className='table-conent'>
                        <Table header={ ['車輛上線時間', '車輛下線時間'] } body={ () => (
                            <tbody>
                            {
                                source?.map((content, index) => (
                                    <tr key={ `${index}-${content.activityMasterId}` } style={{whiteSpace: 'nowrap'}}>
                                        <td>{ content.onlineTime ? dayjs(content.onlineTime).format('YYYY/MM/DD HH:mm:ss') : ''}</td>
                                        <td>{ content.offlineTime ? dayjs(content.offlineTime).format('YYYY/MM/DD HH:mm:ss') : ''}</td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        )} />
                    </div>
                    <div className="button-container">
                        <Button variant="secondary" data-shadow onClick={ cancelHandler }>關閉</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </PaginationProvider>
    )
};

export default Connectionmodal;